"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMCodeHelperGroup = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../../container/ServiceIdentifiers");
const TCustomCodeHelperFactory_1 = require("../../../types/container/custom-code-helpers/TCustomCodeHelperFactory");
const TIdentifierNamesGeneratorFactory_1 = require("../../../types/container/generators/TIdentifierNamesGeneratorFactory");
const IOptions_1 = require("../../../interfaces/options/IOptions");
const IRandomGenerator_1 = require("../../../interfaces/utils/IRandomGenerator");
const IVMBytecodeStorage_1 = require("../../../interfaces/vm-transformers/IVMBytecodeStorage");
const IVMOpcodeMap_1 = require("../../../interfaces/vm-transformers/IVMOpcodeMap");
const Initializable_1 = require("../../../decorators/Initializable");
const CustomCodeHelper_1 = require("../../../enums/custom-code-helpers/CustomCodeHelper");
const AbstractCustomCodeHelperGroup_1 = require("../../AbstractCustomCodeHelperGroup");
let VMCodeHelperGroup = class VMCodeHelperGroup extends AbstractCustomCodeHelperGroup_1.AbstractCustomCodeHelperGroup {
    constructor(customCodeHelperFactory, vmBytecodeStorage, vmOpcodeMapStorage, identifierNamesGeneratorFactory, randomGenerator, options) {
        super(identifierNamesGeneratorFactory, randomGenerator, options);
        this.vmExecutorName = '';
        this.customCodeHelperFactory = customCodeHelperFactory;
        this.vmBytecodeStorage = vmBytecodeStorage;
        this.vmOpcodeMapStorage = vmOpcodeMapStorage;
    }
    initialize() {
        this.customCodeHelpers = new Map();
        if (!this.options.vmObfuscation) {
            return;
        }
        const baseName = this.identifierNamesGenerator.generateForGlobalScope();
        const randomSuffix = Math.floor(this.randomGenerator.getMathRandom() * 16777215).toString(16);
        this.vmExecutorName = `${baseName}_${randomSuffix}`;
        this.identifierNamesGenerator.preserveName(this.vmExecutorName);
        const vmRuntimeHelper = this.customCodeHelperFactory(CustomCodeHelper_1.CustomCodeHelper.VMRuntime);
        vmRuntimeHelper.initialize(this.vmBytecodeStorage, this.vmOpcodeMapStorage, this.vmExecutorName);
        this.customCodeHelpers.set(CustomCodeHelper_1.CustomCodeHelper.VMRuntime, vmRuntimeHelper);
    }
    getVMExecutorName() {
        return this.vmExecutorName;
    }
};
exports.VMCodeHelperGroup = VMCodeHelperGroup;
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", typeof (_g = typeof Map !== "undefined" && Map) === "function" ? _g : Object)
], VMCodeHelperGroup.prototype, "customCodeHelpers", void 0);
exports.VMCodeHelperGroup = VMCodeHelperGroup = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.Factory__ICustomCodeHelper)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMBytecodeStorage)),
    __param(2, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMOpcodeMapStorage)),
    __param(3, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
    __param(4, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IRandomGenerator)),
    __param(5, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [typeof (_a = typeof TCustomCodeHelperFactory_1.TCustomCodeHelperFactory !== "undefined" && TCustomCodeHelperFactory_1.TCustomCodeHelperFactory) === "function" ? _a : Object, typeof (_b = typeof IVMBytecodeStorage_1.IVMBytecodeStorage !== "undefined" && IVMBytecodeStorage_1.IVMBytecodeStorage) === "function" ? _b : Object, typeof (_c = typeof IVMOpcodeMap_1.IVMOpcodeMapStorage !== "undefined" && IVMOpcodeMap_1.IVMOpcodeMapStorage) === "function" ? _c : Object, typeof (_d = typeof TIdentifierNamesGeneratorFactory_1.TIdentifierNamesGeneratorFactory !== "undefined" && TIdentifierNamesGeneratorFactory_1.TIdentifierNamesGeneratorFactory) === "function" ? _d : Object, typeof (_e = typeof IRandomGenerator_1.IRandomGenerator !== "undefined" && IRandomGenerator_1.IRandomGenerator) === "function" ? _e : Object, typeof (_f = typeof IOptions_1.IOptions !== "undefined" && IOptions_1.IOptions) === "function" ? _f : Object])
], VMCodeHelperGroup);
